import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import * as moment from "moment";
import { forkJoin, Observable, Subject } from "rxjs";
import { switchMap, takeUntil } from "rxjs/operators";
import { GLOBAL } from "src/app/app.globals";
import { SharedService } from "src/app/core/services";
import { LogHelperService } from "src/app/core/services/log-helper.service";
import { ContractorType, GatePassAccociateInformation, GatepassRequestProcess } from "./gatepass-request-process.model";
import { GatepassRequestProcessService } from "./gatepass-request-process.service";
import { GatePassRequestsService } from "../gate-pass-requests.service";
import { DataShareService } from "src/app/service/data-share.service";
import { DynamicApicallService } from "src/app/service/dynamic-apicall.service";
import { ApiCallService } from "src/app/service/api-call.service";

const browserWindow = window || {};
const browserWindowEnv = browserWindow['__env'] || {};

@Component({
  selector: 'app-gatepass-request-process',
  templateUrl: './gatepass-request-process.component.html',
  styleUrls: ['./gatepass-request-process.component.css'],
  providers: [GatepassRequestProcessService]
})
export class GatePassRequestProcessComponent implements OnInit {

  @Input() requestType: number;
  @Input() contractorList: any[] = [];
  @Input() contractorInformation: any;
  @Input() userSiteCode: any;

  @Output() handleClose: EventEmitter<void>;
  isContractor: boolean;
  allStepDataObj: GatepassRequestProcess = {};
  currentStep: number = 0;
  workorderList: any[] = [];
  selectedReqData: any[] = [];
  plantList: any[] = [];
  licenseList: any[] = [];
  wcPolicyList: any[] = [];
  associateList: any[] = [];
  associateCount: string;
  isResingationInput: boolean;
  isDisableWorkOrderPrevBtn: boolean;
  isDisableContractorPrevBtn: boolean;
  globalSettings: any[] = [];
  alertMessages: any[] = [];
  selectedPlant: any;
  licenseReqObj: any;
  objectAfterPlantSelect: any;
  stateCapacityCheck: any;
  checkConditionForRemaining: any;
  selectedWorkOrderDetail: any;
  selectedPlantDetail: any;
  workOrderCode: any;
  contractorCode: any;

  private destroy: Subject<void>;

  private useRoles: any[] = [];

  constructor(
    private sharedService: SharedService,
    private gatePassRequestProcessService: GatepassRequestProcessService,
    private logHelperService: LogHelperService,
    private apiCall: DynamicApicallService,
    private globalApiCall: ApiCallService,
    public gatepassService: GatePassRequestsService,
    private dataShareService: DataShareService
  ) {
    this.handleClose = new EventEmitter<void>();
    this.destroy = new Subject<void>();
    this.useRoles = this.getCurrentUserRoles();
    this.isContractor = this.useRoles.some(item => item.Role_Code === 119);
    if (this.isContractor) {
      this.allStepDataObj = { ...this.allStepDataObj };
    }
  }

  ngOnInit(): void {
    this.allStepDataObj = { ...this.allStepDataObj, requestType: this.requestType };
    this.gatepassService.getRequestTypeText(this.allStepDataObj);
    this.checkGlobalSettingsForVisibility();
    this.getAlertMessageFromGlobalSource();
    // this.stateCapacityCheck = this.globalSettings.find(item => item.Code === browserWindowEnv.STATE_CAPACITY_EXCEED_STATUS).Value;
    this.stateCapacityCheck = this.globalSettings.find(item => item.Code === 'MOD52PG195REQLICCAP').Value;
    this.checkConditionForRemaining = this.globalSettings.find(item => item.Code === 'MOD52PG195REQWOCAP').Value;
  }

  onAccociateInformationChange({ contractorType }: GatePassAccociateInformation): void {
    this.allStepDataObj = { ...this.allStepDataObj, contractorType: contractorType, Role_Code: this.useRoles[0].Role_Code };
    if (this.isContractor) {
      this.getContractors(1, true);
      this.allStepDataObj = { ...this.allStepDataObj, contractorType: contractorType, ContractorVendor_Code: this.contractorInformation.ContractorVendor_Code };
      this.currentStep = 3;
    } else {
      this.allStepDataObj = { ...this.allStepDataObj, contractorType: contractorType };
      this.currentStep = 2;
    }
  }

  onContractorSelection(data: any): void {
    this.dataShareService.contractorFlowArrayDataShareService.push(data);
    const newObj: GatepassRequestProcess = {
      ...(this.allStepDataObj.isSubContractorFlowStarted && { SubContractor_Code: data.ContractorVendor_Code, SubCompany: data.Company }),
      ...(!this.allStepDataObj.isSubContractorFlowStarted && { ContractorVendor_Code: data.ContractorVendor_Code, Company: data.Company })
    };

    this.allStepDataObj = { ...this.allStepDataObj, ...newObj };
    const requestObj = this.createWorkOrderListRequest(this.allStepDataObj);
    this.gatePassRequestProcessService.getWorkOrders(requestObj).subscribe((res: any) => {
      if (res) {
        this.workorderList = res;
        this.currentStep = 3;
      }
    });
  }

  oldSelectedWorkOrderDetails: any;
  isFromMainWorkOrder: boolean = false;
  onWorkorderSelection(item: any): void {
    this.dataShareService.workOrderFlowArrayDataShareService.push(item)
    this.oldSelectedWorkOrderDetails = this.selectedWorkOrderDetail;
    this.selectedWorkOrderDetail = item
    const finalObj: GatepassRequestProcess = {
      ...this.allStepDataObj,
      ...(this.allStepDataObj.isSubContractorFlowStarted && { SubWorkOrder_Code: item.WorkOrder_Code, SubWorkOrderNo: item.WorkOrderNo, SubPlant: item.Plant }),
      ...(!this.allStepDataObj.isSubContractorFlowStarted && { WorkOrder_Code: item.WorkOrder_Code, WorkOrderNo: item.WorkOrderNo, Plant: item.Plant })
    };
    this.allStepDataObj = { ...this.allStepDataObj, ...finalObj };
    if (this.allStepDataObj.requestType === 105 && this.allStepDataObj.contractorType != 'SUB_CONTRACTORS_MAN') {
      const data = this.globalSettings.find(item => item.Code === 'MOD152PG198C100FV2');
      if (data) {
        this.associateCount = data.Value
      }
      this.currentStep = 9;
      const requestObj = this.createGatepassListRequest(this.allStepDataObj);
      this.gatePassRequestProcessService.getGatepassList(requestObj).subscribe((res: any[]) => {
        this.associateList = res;
      });
      return;
    } else if (this.allStepDataObj.requestType === 105 && this.allStepDataObj.contractorType == 'SUB_CONTRACTORS_MAN') {
      if (this.isFromMainWorkOrder == true) {
        const data = this.globalSettings.find(item => item.Code === 'MOD152PG198C100FV2');
        if (data) {
          this.associateCount = data.Value
        }
        this.currentStep = 9;
        const requestObj = this.createGatepassListRequest(this.allStepDataObj);
        this.gatePassRequestProcessService.getGatepassList(requestObj).subscribe((res: any[]) => {
          this.associateList = res;
        });
        return;
      } else {
        this.getContractors(0);
        this.currentStep = 2;
        this.isFromMainWorkOrder = true;
        return;
      }

    }
    this.objectAfterPlantSelect = finalObj;

    this.licenseReqObj = this.createLicenseListRequest(finalObj);
    const reqObj = this.createPlantListRequest(item.WorkOrder_Code);
    this.gatePassRequestProcessService.getPlantList(reqObj).subscribe((res: any) => {
      this.plantList = res;
      if (this.plantList.length === 1) {
        this.onPlantSelection(this.plantList[0]);
      } else {
        this.currentStep = 4;
      }
    })
  }

  checkCondition: any;
  onPlantSelection(data: any): void {
    this.selectedPlantDetail = data
    this.selectedPlant = data;
    this.gatePassRequestProcessService.getLicenseByContractor(this.licenseReqObj).subscribe((res: any[]) => {
      this.checkCondition = this.globalSettings.find(item => item.Code === 'MOD52PG195REQLICCAP').Value;
      if (res.length < 1) {
        // let msg = this.alertMessages.find(item => item.Short_Code === 'MSG195_8').MSG;
        // msg = msg.replaceAll('{State}', data.State);
        // msg = msg.replaceAll('{Value}', data.LicenseMaxValue);
        // if (this.selectedWorkOrderDetail.ActivePerson < this.selectedPlant.LicenseMaxValue) {
        //   this.licenseList = [];
        //   this.currentStep = 5;
        // } else if (this.selectedWorkOrderDetail.ActivePerson >= this.selectedPlant.LicenseMaxValue) {
        //   if (this.checkCondition == "1") {
        //     this.logHelperService.logError({
        //       message: msg,
        //       html: true
        //     })
        //   } else if (this.checkCondition == "2") {
        //     this.logHelperService.logError({
        //       title: 'Warning!',
        //       message: msg,
        //       html: true
        //     }, 'warning', 'Go to Next', true).then((confirmRes) => {
        //       if (confirmRes && confirmRes.value) {
        //         this.licenseList = [];
        //         this.currentStep = 5;
        //       }
        //     })
        //   } else {
        //     this.licenseList = [];
        //     this.currentStep = 5;
        //   }
        // }
        this.licenseList = res;
        this.currentStep = 5;
      } else {
        if (res.length === 1) {
          this.licenseList = res;
        } else {
          this.licenseList = res
          // this.licenseList = res.filter(element => {
          //   if (element.Plant_Code == this.selectedPlant.ParentPlant_Code) {
          //     return element;
          //   }
          // });
          // if(activePersonSum > this.selectedPlant.LicenseMaxValue && this.checkConditionForRemaining !== "2") {
          //   this.logHelperService.logError({
          //     message: `As per CLRA, ${this.selectedPlant.State} state has allowed only ${this.selectedPlant.LicenseMaxValue} gate pass without Labour License`
          //   })
          // }
        }
        // const Remaining = this.licenseList[0].Person - this.licenseList[0].ActivePerson;
        // this.licenseList[0].Remaining = Remaining;
        this.licenseList.forEach(license => {
          Object.assign(license, { Remaining: license.Person - license.ActivePerson })
          if (this.selectedWorkOrderDetail.ActivePerson > this.selectedPlant.LicenseMaxValue && this.checkConditionForRemaining !== "2") {
            this.logHelperService.logError({
              message: `As per CLRA, ${this.selectedPlant.State} state has allowed only ${this.selectedPlant.LicenseMaxValue} gate pass without Labour License`
            })
          }
        });

        let activePersonSum = 0;
        this.licenseList.forEach((lic) => {
          activePersonSum = activePersonSum + lic.ActivePerson;
        })

        this.currentStep = 5;
        this.allStepDataObj = { ...this.allStepDataObj, ...this.objectAfterPlantSelect };
      }
    });
  }

  onLicenseSelection(data: any): void {
    this.allStepDataObj = { ...this.allStepDataObj, ...data };
    if (!this.allStepDataObj.isSubContractorFlowStarted) {
      if (this.allStepDataObj.isSkipLicense) {
        this.currentStep = 6;
      }
      return;
    }

    if (this.allStepDataObj.isSkipWCPolicy || this.allStepDataObj.labourCoverType === 'esic') {
      let reqObj = {
        Role_Code: this.useRoles[0].Role_Code,
        UserId: GLOBAL.USER_ID,
        IsActive: this.allStepDataObj.requestType === 103 ? 1 : 0,
        Contractor_Code: this.contractorCode,
        WorkOrder_Code: this.workOrderCode,
        SubWorkOrder_Code: this.selectedWorkOrderDetail.WorkOrder_Code,
        ActionType: 1,
        Search: null,
        SelectedField: null,
        Condition: null,
        FilterType: null
      }
      this.gatePassRequestProcessService.getWCPolicyNewList(this.allStepDataObj.WorkOrder_Code, reqObj).subscribe((wcPolicyData: any) => {
        this.wcPolicyList = wcPolicyData;
        this.allStepDataObj = { ...this.allStepDataObj, labourCoverType: data.labourCoverType };
      });
      if (this.allStepDataObj.isSubContractorFlowStarted && this.allStepDataObj.isSkipWCPolicy && this.allStepDataObj.labourCoverType === 'wcPolicy') {
        if (this.allStepDataObj.isSkipLicense == true) {
          this.currentStep = 7;
        }
      } else {
        if (this.allStepDataObj.isSkipLicense == true) {
          this.currentStep = 8;
        }
      }
      return;
    }

    if (this.allStepDataObj.isSkipWCPolicy && this.allStepDataObj.labourCoverType === 'wcPolicy') {
      this.currentStep = 7;
      return;
    } else if (this.allStepDataObj.isSubContractorFlowStarted && this.allStepDataObj.labourCoverType === 'wcPolicy' && this.allStepDataObj.ECPolicy_Code) {
      this.currentStep = 8;
      return;
    } else {
      if (this.allStepDataObj.isSkipLicense == true) {
        this.currentStep = 6;
      }
    }

  }
  selectedAssociateCoverUnder: any
  public onAssociateCoverUnderSelection(data: any): void {
    console.log('data', data);
    this.selectedAssociateCoverUnder = data.labourCoverType
    if (this.allStepDataObj.contractorType === 'SUB_CONTRACTORS_MAN' && !this.allStepDataObj.isSubContractorFlowStarted && data.labourCoverType === 'esic') {
      this.contractorList = [];
      this.getContractors(0);
      this.currentStep = 2;
      this.allStepDataObj = { ...this.allStepDataObj, isSubContractorFlowStarted: true, labourCoverType: data.labourCoverType, };
      return;
    }

    if (this.allStepDataObj.contractorType === 'SUB_CONTRACTORS_MAN' && data.labourCoverType === 'esic') {
      this.contractorList = [];
      this.getContractors(0);
      this.currentStep = 2;
      this.allStepDataObj = { ...this.allStepDataObj, labourCoverType: data.labourCoverType };
      return;
    }
    if (data.labourCoverType === 'wcPolicy') {
      let reqObj = {
        Role_Code: this.useRoles[0].Role_Code,
        UserId: GLOBAL.USER_ID,
        IsActive: this.allStepDataObj.requestType === 103 ? 1 : 0,
        Contractor_Code: this.allStepDataObj.ContractorVendor_Code,
        WorkOrder_Code: this.selectedWorkOrderDetail.WorkOrder_Code,
        SubWorkOrder_Code: this.allStepDataObj.SubWorkOrder_Code ? this.allStepDataObj.SubWorkOrder_Code : null,
        ActionType: 1,
        Search: null,
        SelectedField: null,
        Condition: null,
        FilterType: null
      }
      this.gatePassRequestProcessService.getWCPolicyNewList(this.allStepDataObj.WorkOrder_Code, reqObj).subscribe((wcPolicyData: any) => {
        this.wcPolicyList = wcPolicyData;
        this.currentStep = 7;
        this.allStepDataObj = { ...this.allStepDataObj, labourCoverType: data.labourCoverType };
      });
    } else {
      this.currentStep = 8;
      this.allStepDataObj = { ...this.allStepDataObj, labourCoverType: data.labourCoverType };
    }
  }

  onWCPolicySelection(data: any): void {
    if (this.allStepDataObj.contractorType === 'SUB_CONTRACTORS_MAN' && !this.allStepDataObj.isSubContractorFlowStarted) {
      this.contractorList = [];
      this.getContractors(0);
      this.currentStep = 2;
      this.allStepDataObj = { ...this.allStepDataObj, ...data, isSubContractorFlowStarted: true };
      return;
    }

    this.currentStep = 8;
    this.allStepDataObj = { ...this.allStepDataObj, ...data };

  }

  onGatepassJobTypeSelection(data: any): void {
    const requestObj = this.createGatepassListRequest({ ...this.allStepDataObj, jobType: data.jobType });
    this.gatePassRequestProcessService.getGatepassList(requestObj).subscribe((res: any[]) => {
      this.associateList = res;
      let minimumRemainingValue = [];
      const workOrderCapacityCheck = this.globalSettings.find(item => item.Code === 'MOD52PG195REQWOCAP');
      const licenseCapacityCheck = this.globalSettings.find(item => item.Code === 'MOD52PG195REQLICCAP');
      const wcPolicyCapacityCheck = this.globalSettings.find(item => item.Code === 'MOD52PG195REQECCAP');
      if (this.allStepDataObj.requestType == 103) {
        if (this.allStepDataObj && this.allStepDataObj.ECPolicy_Code && wcPolicyCapacityCheck && wcPolicyCapacityCheck.Value == '1') {
          let currentWCPolicy = this.wcPolicyList.find(wc => wc.ECPolicy_Code == this.allStepDataObj.ECPolicy_Code)
          if (currentWCPolicy) {
            minimumRemainingValue.push(currentWCPolicy.RemainingPerson)
          }
        }
        if (this.selectedWorkOrderDetail && this.selectedWorkOrderDetail.Remaining && workOrderCapacityCheck && workOrderCapacityCheck.Value == '1') {
          minimumRemainingValue.push(this.selectedWorkOrderDetail.Remaining)
        }
        if (this.allStepDataObj && this.allStepDataObj.Remaining && licenseCapacityCheck && licenseCapacityCheck.Value == '1') {
          minimumRemainingValue.push(this.allStepDataObj.Remaining)
        } else if (this.selectedPlant && licenseCapacityCheck && licenseCapacityCheck.Value == '1') {
          minimumRemainingValue.push(this.selectedPlant.LicenseMaxValue - this.selectedPlant.Active);
        }
      }
      const data = this.globalSettings.find(item => item.Code === 'MOD152PG198C100FV2');
      if (data) {
        minimumRemainingValue.push(data.Value);
      }
      this.associateCount = minimumRemainingValue.reduce((a, b) => Math.min(parseFloat(a), parseFloat(b)));
      this.allStepDataObj = { ...this.allStepDataObj, jobType: data.jobType };
      this.currentStep = 9;
    });
  }

  laboourData: any = []
  onSubmit(data: any): void {
    if (this.allStepDataObj.requestType !== 105) {
      data.forEach(element => {
        let reqObj = {
          Labour_Code: element.Labour_Code,
          Request_Code: element.Request_Code,
          Action: 0,
          RequestType: 0,
          RequestedUserID: GLOBAL.USER_ID
        }
        this.laboourData.push(reqObj)
      });

      this.globalApiCall.onSubmitNewRequest(this.laboourData).subscribe((response) => {
      });
    }
    if (this.allStepDataObj.requestType === 105) {
      this.onCancelRequestSubmit(data);
      return;
    }
    if (this.allStepDataObj.requestType === 104) {
      this.onRenewRequestSubmit(data);
      return;
    }
    if (this.allStepDataObj.requestType === 103) {
      this.onNewRequestSubmit(data);
      return;
    }
  }

  onNewRequestSubmit(data: any): void {
    const objgatepass = this.prepareReqForActionSave({ ...this.allStepDataObj, labourCodes: data, actions: 'Approved' });
    this.gatePassRequestProcessService.insertGatePassRequest(objgatepass).subscribe((insertGetPassRequestResponse: any) => {
      this.logHelperService.logSuccess({
        message: 'Onboarding Request submitted successfully'
      });
      this.onClose({ refreshList: true });
    });
  }

  onRenewRequestSubmit(data: any): void {
    const objgatepass = this.prepareReqForActionSave({ ...this.allStepDataObj, labourCodes: data, actions: 'Approved' });
    this.gatePassRequestProcessService.insertGatePassRequestRenew(objgatepass).subscribe((insertGetPassRequestResponse: any) => {
      this.logHelperService.logSuccess({
        message: 'Onboarding Request submitted successfully'
      });
      this.onClose({ refreshList: true });
    });
  }

  onCancelRequestSubmit(data: any): void {
    const objgatepass = this.prepareReqForActionSave({ ...this.allStepDataObj, labourCodes: data, actions: 'Approved' });
    let payload = [];

    objgatepass.forEach((items) => {
      let reqObj = {
        GatepassNo: items.GatePassNo,
        RequestType: 105,
        RoleCode: GLOBAL.ROLE_CODE,
        isLabour: 1,
        RequestedUserID: GLOBAL.USER_ID
      }
      payload.push(reqObj)
    })

    this.gatePassRequestProcessService.insertGatePassRequestCancel(payload).pipe(switchMap(response => {
          const cancelObj = this.prepareReqForCancelActionSave({ ...this.allStepDataObj, labourCodes: data });
          return this.gatePassRequestProcessService.insertGatePassRequestBulkCancel(cancelObj);
        })
      )
      .subscribe((insertGetPassRequestResponse: any) => {
        // this.gatePassRequestProcessService.insertGatePassRequest(objgatepass).subscribe((insertGetPassRequestResponse: any) => {
        this.logHelperService.logSuccess({
          message: 'Onboarding Request submitted successfully'
        });
        this.onClose({ refreshList: true });
      });
  }

  onPrevAction(step: number): void {
    this.currentStep = step;
  }

  onAssociateSelectionPrevAction(): void {
    if (this.allStepDataObj.requestType === 105) {
      this.currentStep = 3;
    } else {
      this.currentStep = 8;
    }
  }

  onWorkOrderSelectionPrevAction(): void {
    this.selectedWorkOrderDetail = this.oldSelectedWorkOrderDetails;
    if (this.allStepDataObj.contractorType === 'SUB_CONTRACTORS_MAN' && !!this.allStepDataObj.isSubContractorFlowStarted) {
      this.currentStep = 2;
      return;
    }
    if (this.isContractor) {
      this.currentStep = 1;
    } else {
      this.currentStep = 2;
    }
  }

  onWCPolicyPrevAction(step: number): void {
    if (this.allStepDataObj.isSubContractorFlowStarted && !!this.allStepDataObj.SubWorkOrder_Code) {
      this.currentStep = 5;
      return;
    }
    if (this.allStepDataObj.isSubContractorFlowStarted) {
      this.currentStep = 6;
      return;
    }
    if (this.allStepDataObj.isSubContractorFlowStarted && this.allStepDataObj.isSkipWCPolicy && this.allStepDataObj.labourCoverType === 'wcPolicy') {
      this.currentStep = 7;
      return;
    }
    if (this.allStepDataObj.labourCoverType === 'wcPolicy') {
      this.currentStep = 6;
      return;
    }
    this.currentStep = 6;
  }

  onGatepassJobTypePrevAction(step: number): void {
    if (this.allStepDataObj.isSubContractorFlowStarted && this.allStepDataObj.isSkipWCPolicy && this.allStepDataObj.labourCoverType === 'wcPolicy') {
      this.currentStep = 7;
      return;
    }
    if (this.allStepDataObj.isSubContractorFlowStarted && this.allStepDataObj.labourCoverType === 'wcPolicy') {
      this.currentStep = 5;
      return;
    }
    if (this.allStepDataObj.isSubContractorFlowStarted && this.allStepDataObj.labourCoverType === 'esic') {
      this.currentStep = 6;
      return;
    }
    if (this.allStepDataObj.labourCoverType === 'wcPolicy') {
      this.currentStep = 7;
      return;
    }
    this.currentStep = 6;
  }

  onClose(data?: any): void {
    this.dataShareService.contractorFlowArrayDataShareService = [];
    this.dataShareService.workOrderFlowArrayDataShareService = [];
    this.dataShareService.newLicenseFlowArrayDataShareService = [];
    this.dataShareService.oldLicenseFlowArrayDataShareService = [];
    this.handleClose.emit(data);
  }

  getAlertMessageFromGlobalSource(): void {
    this.sharedService.alertMessages$.subscribe((alertMessages: any[]) => {
      this.alertMessages = alertMessages;
    });
  }
  checkGlobalSettingsForVisibility(): void {
    this.sharedService.globalSettingsDataSource$.subscribe((settings: any) => {
      if (settings && settings.Data && settings.Data.Table) {
        this.globalSettings = settings.Data.Table;
        this.checkSettingForFirstStep(settings.Data.Table);
        // this.checkSettingForAssociateCount(settings.Data.Table);
        this.checkSettingForResignationInput(settings.Data.Table);
      }
    });
  }

  checkSettingForFirstStep(settings: any[]): void {
    const data = settings.find(item => item.Code === 'MOD52PG195REQSUBCON');
    if (data) {
      let value = data.Value;
      if (this.userSiteCode === data.Plant_Code) {
        value = data.Value;
      }
      if (value === '1') {
        this.currentStep = 1;
        this.getContractors();
      } else if (this.isContractor) {
        this.allStepDataObj = { ...this.allStepDataObj, contractorType: ContractorType.Contractor };
        // this.currentStep = 3;
        this.isDisableWorkOrderPrevBtn = true;
        this.getContractors(1, true);
        // this.onContractorSelection({ ContractorVendor_Code: null, Company: '' })
      } else {
        this.allStepDataObj = { ...this.allStepDataObj, contractorType: ContractorType.Contractor };
        this.currentStep = 2;
        this.isDisableContractorPrevBtn = true;
        this.getContractors();
      }
    }
  }

  // private checkSettingForAssociateCount(settings: any[]): void {
  //   const data = settings.find(item => item.Code === 'MOD152PG198C100FV2');
  //   if (data) {
  //     this.associateCount = data.Value;
  //   }
  // }

  checkSettingForResignationInput(settings: any[]): void {
    const data = settings.find(item => item.Code === 'MOD152PG198C100FV1');
    if (data && this.allStepDataObj.requestType === 105) {
      this.isResingationInput = !!(+data.Value);
    }
  }

  getContractors(isMain = 1, isCallContractorSelection: boolean = false): void {
    if (this.useRoles) {
      const reuqestObj = this.createContractorListRequest(this.allStepDataObj, isMain)
      this.gatePassRequestProcessService.getContractors(reuqestObj)
        .pipe(takeUntil(this.destroy))
        .subscribe(res => {
          this.contractorList = res;
          if (res && res.length > 0 && isCallContractorSelection) {
            this.onContractorSelection({ ContractorVendor_Code: this.contractorList[0].ContractorVendor_Code, Company: this.contractorList[0].Company })
          }
        })
    }
  }

  getCurrentUserRoles(): any {
    return JSON.parse(localStorage.getItem('Role'));
  }

  createContractorListRequest({ ContractorVendor_Code = null, WorkOrder_Code = null, contractorType }: GatepassRequestProcess, isMain): any {
    this.contractorCode = ContractorVendor_Code;
    return {
      search: null,
      sDate: null,
      eDate: null,
      selectedField: 'Company,ContractorVendor_Code,EmailID,ShortCode,PANNo,IsContactor,Status',
      isMain,
      Contractor_Code: isMain === 1 ? null : ContractorVendor_Code,
      ExcludeContractor_Code: isMain === 1 ? null : ContractorVendor_Code,
      workOrderCode: WorkOrder_Code,
      Plant_Code: null,
      UserID: GLOBAL.USER_ID,
      RequirType: null
    }
  }

  createWorkOrderListRequest({ ContractorVendor_Code, WorkOrder_Code = null, SubContractor_Code, Role_Code }: GatepassRequestProcess): any {
    this.workOrderCode = this.selectedWorkOrderDetail ? this.selectedWorkOrderDetail.WorkOrder_Code : null

    if (this.allStepDataObj.requestType == 105) {
      if (this.dataShareService.contractorFlowArrayDataShareService.length === 1) {
        return {
          Role_Code,
          UserId: GLOBAL.USER_ID,
          ContractorVendor_Code,
          ActionType: 1,
          WorkOrder_Code: this.selectedWorkOrderDetail ? this.selectedWorkOrderDetail.WorkOrder_Code : null,
          Plant_Code: null,
          Search: null,
          selectedField: null
        }
      } else {
        return {
          Role_Code,
          UserId: GLOBAL.USER_ID,
          ContractorVendor_Code: this.dataShareService.contractorFlowArrayDataShareService[0].ContractorVendor_Code,
          SubContractorVendor_Code: ContractorVendor_Code,
          ActionType: 1,
          WorkOrder_Code: this.selectedWorkOrderDetail ? this.selectedWorkOrderDetail.WorkOrder_Code : null,
          Plant_Code: null,
          Search: null,
          selectedField: null
        }
      }
    } else {
      return {
        Role_Code,
        UserId: GLOBAL.USER_ID,
        ContractorVendor_Code,
        SubContractorVendor_Code: SubContractor_Code,
        ActionType: 1,
        WorkOrder_Code: this.selectedWorkOrderDetail ? this.selectedWorkOrderDetail.WorkOrder_Code : null,
        Plant_Code: null,
        Search: null,
        selectedField: null
      }
    }
  }

  createPlantListRequest(workOrder_Code) {
    return {
      search: null,
      selectedField: null,
      WorkOrder: this.allStepDataObj.isSubContractorFlowStarted ? this.workOrderCode : workOrder_Code,
      SubWorkOrder: this.allStepDataObj.isSubContractorFlowStarted ? workOrder_Code : null,
      UserID: GLOBAL.USER_ID,
      ActionType: 0,
      RequireType: 0,
    }
  }

  createLicenseListRequest({ ContractorVendor_Code, WorkOrder_Code, SubContractor_Code, Plant_Code, SubWorkOrder_Code = null }: GatepassRequestProcess): any {
    return {
      Role_Code: this.useRoles[0].Role_Code,
      UserId: GLOBAL.USER_ID,
      IsActive: this.allStepDataObj.requestType === 103 ? 1 : 0,
      Contractor_Code: ContractorVendor_Code,
      WorkOrder_Code: this.allStepDataObj.isSubContractorFlowStarted ? this.workOrderCode : WorkOrder_Code,
      // SubContractor_Code,
      // Plant_Code,
      SubWorkOrder_Code,
      ActionType: 1
    }
  }

  createGatepassListRequest(data: GatepassRequestProcess): any {
    if (this.allStepDataObj.requestType !== 104) {
      let baseData = {
        labourcovered: this.selectedAssociateCoverUnder,
        Contractor_Code: data.ParentContractorVendor_Code ? data.ParentContractorVendor_Code : data.ContractorVendor_Code,
        WorkOrder_Code: data.WorkOrder_Code,
        License_Code: data.License_Code,
        NewLicense_Code: null,
        ECPolicy_Code: data.ECPolicy_Code,
        NewECPolicy_Code: data.NewECPolicy_Code,
        ESICWageCriteria: null,
        RequestType_ShortCode: this.getRequestType(data.requestType),
      };

      if (this.allStepDataObj.requestType === 105) {
        let contractorData = {
          Contractor_Code: this.dataShareService.contractorFlowArrayDataShareService[0].ContractorVendor_Code || this.allStepDataObj.ContractorVendor_Code,
          WorkOrder_Code: this.dataShareService.workOrderFlowArrayDataShareService[0].WorkOrder_Code || data.WorkOrder_Code,
        };

        if (this.dataShareService.contractorFlowArrayDataShareService.length > 1) {
          return {
            ...baseData,
            ...contractorData,
            SubContractorcode: data.ContractorVendor_Code,
            SubWorkorder: data.WorkOrder_Code,
            SubLicense_Code: data.License_Code,
            SubNewLicense_Code: null,
          };
        }

        return { ...baseData, ...contractorData };
      }

      if (this.allStepDataObj.contractorType === "CONTRACTORS_MAN") {
        return baseData;
      }

      return {
        ...baseData,
        SubContractorcode: data.SubContractor_Code,
        SubWorkorder: data.SubWorkOrder_Code,
        SubLicense_Code: data.License_Code,
        SubNewLicense_Code: null,
      };

    } else {
      let oldContractor = this.dataShareService.oldLicenseFlowArrayDataShareService.filter(item => !item.isSubContractorFlowStarted) || [];
      let oldSubContractor = this.dataShareService.oldLicenseFlowArrayDataShareService.filter(item => item.isSubContractorFlowStarted) || [];
      let newContractor = this.dataShareService.newLicenseFlowArrayDataShareService.filter(item => !item.isSubContractorFlowStarted) || [];
      let newSubContractor = this.dataShareService.newLicenseFlowArrayDataShareService.filter(item => item.isSubContractorFlowStarted) || [];

      let reqObj = {
        Contractor_Code: data.ParentContractorVendor_Code ? data.ParentContractorVendor_Code : data.ContractorVendor_Code,
        ESICWageCriteria: null,
        License_Code: oldContractor.length ? oldContractor[0].License_Code : null,
        NewLicense_Code: newContractor.length ? newContractor[0].License_Code : null,
        RequestType_ShortCode: this.getRequestType(data.requestType) || null,
        SubLicense_Code: oldSubContractor.length ? oldSubContractor[0].License_Code : null,
        SubNewLicense_Code: newSubContractor.length ? newSubContractor[0].License_Code : null,
        SubContractorcode: data.SubContractor_Code || null,
        SubWorkorder: data.SubWorkOrder_Code || null,
        WorkOrder_Code: data.WorkOrder_Code || null,
        labourcovered: this.selectedAssociateCoverUnder || null,
      }

      return reqObj
    }
  }

  prepareReqForActionSave(data: GatepassRequestProcess): any {
    let oldSubContractor = this.dataShareService.oldLicenseFlowArrayDataShareService.filter(item => item.isSubContractorFlowStarted) || [];
    let newSubContractor = this.dataShareService.newLicenseFlowArrayDataShareService.filter(item => item.isSubContractorFlowStarted) || [];
     
    const labourCodes = data.labourCodes.map(item => item.Labour_Code);
    const objgatepass = {
      Reqtype: data.requestType,
      RoleCode: data.Role_Code,
      subContractorcode: data.SubContractor_Code,
      Labour_codes: labourCodes,
      Plant_code: data.Plant_Code,
      State_Code: 111,
      UserEmail: GLOBAL.USER.EMAIL_ID,
      companypolicyCode: null,
      contractorcode: data.ParentContractorVendor_Code ? data.ParentContractorVendor_Code : data.ContractorVendor_Code,
      isLabour: 1,
      subworkoderordercode: data.SubWorkOrder_Code,
      workoderordercode: data.WorkOrder_Code,
      labourcovered: this.selectedAssociateCoverUnder,
      licensecode: data.License_Code,
      subPlant_Code: data.ChildPlant_Code,
      sublincensecode: data.contractorType === "SUB_CONTRACTORS_MAN" && data.requestType === 104 ? newSubContractor.length > 0 ? newSubContractor[0].License_Code : oldSubContractor[0].License_Code : null,
      wcpolicycode: data.ECPolicy_Code,
      Job: data.jobType,
      UserId: GLOBAL.USER_ID
    };

    return data.requestType !== 105 ? objgatepass : data.labourCodes;
  }

  prepareReqForCancelActionSave(data: GatepassRequestProcess): any {
    return data.labourCodes.map(item => ({
      GatePassNo: item.GatePassNo,
      RequirType: 1,
      ActionType: 1,
      IsLabour: true,
      CloseDate: moment(item.resignDate).format(this.sharedService.datePickerSettings.requestFormat),
      UserId: GLOBAL.USER_ID
    }));
  }

  getRequestType(type: number): string {
    const requestTypeObj = {
      103: 'RT103',
      104: 'RT104',
      105: 'RT105',
    };

    return requestTypeObj[type];
  }
}